var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-white",class:_vm.classes,style:(_vm.styles),attrs:{"disabled":_vm.loading || _vm.disabled}},[(_vm.loading)?_c('v-loader',{attrs:{"size":"sm"}}):_c('i',{class:_vm.active ? (_vm.activeIcon ?? _vm.icon) : _vm.icon,style:(_vm.iconStyles)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }